import {
    NinchatActionType,
    NinchatCreateQueueAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'

import {NinchatQueueCreatedEvent} from 'api/types/events'
import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const createQueue = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatCreateQueueAction}`,
    async (arg: NinchatActionParams<NinchatCreateQueueAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatCreateQueueAction

        try {
            return await ninchatClient.send(params) as NinchatQueueCreatedEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
